import React from "react"
import { Header } from "../../components/header/Header";
import { SocialButton } from "../../components/socialButton/SocialButton";
import { useDataContext, useLocale } from "../../services/DataContext";
import { Hypes } from "../hypes/Hypes";
import { SHOW_MENU_DIALOG } from "../../components/Dialog/Utils";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { ActorsPage } from "../actors/ActorsPage";
interface ContentPageProps {

}

export const ContentPage: React.FC<ContentPageProps> = (props) => {
  const l: any = useLocale();
  const params: any = useParams();
  const section = params.section;
  const loadedData = useDataContext();
  if (section !== "hypes" && section !== "actors-and-directors") {
    return <h1>Url is not match <Link to="/">go to start</Link></h1>
  }

  return <div className="content-page">
    <div className="content__wrapper">

      <Header />
      <div className="content-page__menu hide-on-medium">
        <SocialButton
          className="social-button__menu"
          onClick={() => SHOW_MENU_DIALOG(section, l)}>
          <i className="icon-menu" />
        </SocialButton>
      </div>
      <div className="container hide-on-small content__tabs">
        <div className="row animate__animated animate__fadeIn ">
          <div className="col">
            <div className="content-page__tabs">
              <div className={`content-page__tab-item ${section === "hypes" ? "content-page__tab-item--active" : ""}`}>
                <h1><Link to="/content/hypes">{l["hypeTitle"]}</Link></h1>
              </div>
              <div className={`content-page__tab-item ${section === "actors-and-directors" ? "content-page__tab-item--active" : ""}`}>
                <h1><Link to="/content/actors-and-directors">{l["actorsTitle"]}</Link></h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        section === "hypes" &&
        <Hypes data={loadedData.hypes} />
      }
      {
        section === "actors-and-directors" &&
        <ActorsPage />
      }
    </div>
  </div>
}